import { VtmnTabs, VtmnTabsItem } from '@vtmn/react';
import '../navigation-bar.css';

interface TabBarProps {
  total: number;
  setTabViewIndex: (index: number) => void;
  tabViewIndex: number;
}

export const TabBar = ({
  total,
  setTabViewIndex,
  tabViewIndex,
}: TabBarProps) => {
  return (
    <div className="navigation-bar vtmn-justify-between" data-testid="tab-bar">
      <VtmnTabs align="start" size="small">
        <VtmnTabsItem
          data-testid="tab-bar_sm"
          aria-label="supermodels tab"
          onClick={() => setTabViewIndex(0)}
          aria-selected={tabViewIndex === 0}
        >
          SuperModels
        </VtmnTabsItem>
        <VtmnTabsItem
          data-testid="tab-bar_model"
          aria-label="models tab"
          onClick={() => setTabViewIndex(1)}
          aria-selected={tabViewIndex === 1}
        >
          Models
        </VtmnTabsItem>
      </VtmnTabs>
      <p data-testid="total-sm">{total} supermodels</p>
    </div>
  );
};
